module.exports = __webpack_public_path__ + "static/media/contest2025_fifth_place_image.2e12502a.jpeg";